import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_gifts_price: FaireCategoryEntity = {
  token: "cat_gifts-price",
  type: "category",
  name: "By price",
  level: 2,
  parentToken: "cat_gifts",
  href: "/category/gifts/price",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
